var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{},[_c('slide-voyage')],1),_c('div',{staticClass:"section"},[_c('carousel-image')],1),_c('h2',{staticClass:"title text-center"},[_vm._v(_vm._s(_vm.$t("voyage.galerie")))]),_c('galerie')],1)}
var staticRenderFns = []

export { render, staticRenderFns }